import { gql } from '@apollo/client';

/**
 * GraphQL mutation to delete a strike policy
 */
export const DELETE_STRIKE_POLICY = gql`
  mutation DeleteStrikePolicy($communityId: ID!, $input: DeletePolicyInput!) {
    deletePolicy(communityId: $communityId, input: $input)
  }
`;
